module.exports = lib_ui__rc_calendar;